export const ADD_SALARY = "ADD_SALARY";
export const GET_SALARY_LIST = "GET_SALARY_LIST";
export const DELELE_SALARY = "DELELE_SALARY";
export const UPDATE_SALARY = "UPDATE_SALARY";
